// extracted by mini-css-extract-plugin
module.exports = {"waitMode":"Wait_waitMode__-uG6_"};